import React, { forwardRef, PropsWithChildren } from 'react';
import { Divider, ListItem, ListItemText, ListItemProps } from "@mui/material";

export interface MyListItemProps extends PropsWithChildren, ListItemProps {
  item: iKanbanItem,
  props?: any,
}

export const MyListItem = forwardRef(({ item, ...props }: MyListItemProps, ref) => {
  return (
    <>
      <ListItem {...props} ref={ref}>
        <ListItemText>{item.title}</ListItemText>
      </ListItem>
      {/* {props.children} */}
      {/* <Divider /> */}
    </>
  )
});

export default MyListItem;
